import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { getInfo } from 'SRC/modules/users/detail/selectors'
import useTranslation from 'next-translate/useTranslation'
import ReactSVG from 'react-svg'
import { getVehiclePart } from '../../selectors'

const Sidebar = ({ userInfo, vehiclePart }) => {
	const primaryAddress = userInfo?.userAddresses?.find((address) => address?.main)
		|| userInfo?.userAddresses?.[0]
	const cityName = primaryAddress?.city?.name || ''

	const installments = vehiclePart?.installments || []
	const formatAmount = (amount) => {
		if (typeof amount === 'number' && Number.isFinite(amount)) {
			return amount.toFixed(2)
		}
		return amount || ''
	}

	const { t, lang } = useTranslation('common')

	return (
		<aside className='vehicle-part-sidebar'>
			<div className='vehicle-part-sidebar-user'>
				<div className='vehicle-part-sidebar-user__top' />
				<div className='vehicle-part-sidebar-user__info'>
					<div className='vehicle-part-sidebar-user__info-text'>
						<ReactSVG
							src='/icons/username.svg'
							beforeInjection={(svg) => {
								svg.setAttribute('width', '15px')
								svg.setAttribute('height', '15px')
							}}
						/>
						{userInfo?.username || ''}
					</div>
					<div className='vehicle-part-sidebar-user__info-text'>
						<ReactSVG
							src='/icons/location.svg'
							beforeInjection={(svg) => {
								svg.setAttribute('width', '10px')
								svg.setAttribute('height', '14px')

								svg.querySelectorAll('path').forEach(path => {
									path.setAttribute('fill', '#0377cd')
									path.setAttribute('style', 'fill: #0377cd;')
								})
							}}
						/>
						<p>
							{cityName}
						</p>
					</div>
				</div>
				<div className='vehicle-part-sidebar-user__logo'>
					<ReactSVG
						src='/icons/prodavnica-circle.svg'
						wrapper='span'
						beforeInjection={(svg) => {
							svg.setAttribute('width', '82px')
							svg.setAttribute('height', '82px')
						}}
					/>
				</div>

				<div className='vehicle-part-sidebar-user__body'>
					<p className='vehicle-part-sidebar-user__title'>{`${t('auto djelovi')} - AUTO DILER`}</p>
					<p className='vehicle-part-sidebar-user__subtitle'># {t('Prodavnica')}</p>
				</div>
			</div>

			{vehiclePart?.installment_enabled && Array.isArray(installments) && installments.length ? (
				<div className='vehicle-part-sidebar-installments'>
					<div className='vehicle-part-sidebar-installments__header'>
						<span className='vehicle-part-sidebar-installments__icon'>
							<ReactSVG
								src='/icons/na-rate.svg'
								wrapper='span'
								beforeInjection={(svg) => {
									svg.setAttribute('width', '40px')
									svg.setAttribute('height', '40px')
									svg.querySelectorAll('path').forEach(path => {
										path.setAttribute('fill', '#fff')
										path.setAttribute('style', 'fill: #fff;')
									})
								}}
							/>
						</span>
						<div className='vehicle-part-sidebar-installments__header-text'>
							<p className='vehicle-part-sidebar-installments__title'>{t('Plati na rate')}</p>
							<p className='vehicle-part-sidebar-installments__subtitle'>{t('bez kamate i odlaska u banku')}</p>
						</div>
					</div>

					<div className='vehicle-part-sidebar-installments__list'>
						{installments.map((installment, index) => (
							<div className='vehicle-part-sidebar-installments__item' key={`${installment?.months || 'rate'}-${index}`}>
								<div className='vehicle-part-sidebar-installments__item-left'>
									<div className='vehicle-part-sidebar-installments__item-count'>
										{installment?.months}
									</div>
									<div className='vehicle-part-sidebar-installments__item-label'>
										{installment?.months_text?.replace(installment?.months, '')?.trim() || 'RATA'}
									</div>
								</div>
								<div className='vehicle-part-sidebar-installments__item-right'>
									<div className='vehicle-part-sidebar-installments__item-amount'>
										{formatAmount(installment?.amount)}€
									</div>
									<div className='vehicle-part-sidebar-installments__item-period'>{t('Mjesečno')}</div>
								</div>
							</div>
						))}
					</div>
				</div>
			) : null}
		</aside>
	)
}

Sidebar.propTypes = {
	userInfo: PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string,
		username: PropTypes.string,
		userAddresses: PropTypes.arrayOf(PropTypes.shape({
			main: PropTypes.bool,
			country: PropTypes.shape({
				id: PropTypes.number,
				name: PropTypes.string
			}),
			region: PropTypes.shape({
				id: PropTypes.number,
				name: PropTypes.string
			}),
			city: PropTypes.shape({
				id: PropTypes.number,
				name: PropTypes.string
			}),
			location: PropTypes.shape({
				id: PropTypes.number,
				name: PropTypes.string
			})
		}))
	}),
	vehiclePart: PropTypes.shape({
		installments: PropTypes.arrayOf(PropTypes.shape({
			months: PropTypes.number,
			amount: PropTypes.number,
			months_text: PropTypes.string,
		})),
		installment_enabled: PropTypes.bool
	})
}

const mapStateToProps = (state) => ({
	userInfo: getInfo(state),
	vehiclePart: getVehiclePart(state)
})

export default connect(mapStateToProps)(Sidebar)
